import React, {Component} from 'react'
import {Select} from "antd"
import 'antd/lib/select/style/index.css'
import PropTypes from 'prop-types'

const {Option} = Select

class FilterType extends Component {
    _handleChange = (value) => {
        const {onChangeFilters} = this.props

        const filters = Object.assign({}, this.props.filters)
        delete filters['before_id']
        delete filters['after_id']
        filters.types = value

        if (typeof onChangeFilters === 'function') {
            onChangeFilters(filters)
        }
    }

    render() {
        const {filters, types: listTypes} = this.props
        const {types} = filters
        const field = 'product_type'

        return (
            <div className="FilterType w-100 mb-3">
                <label className='font-weight-bold'>Product Types </label>
                <Select
                    mode="multiple"
                    style={{width: '100%'}}
                    showArrow={true}
                    placeholder="Vui lòng chọn loại sản phẩm bạn muốn tìm kiếm"
                    defaultValue={types}
                    onChange={this._handleChange}
                    value={types}
                >
                    {
                        listTypes.length > 0 && listTypes.map((option, index) => {

                            const {name, value} = option

                            return (value !== '' &&
                                <Option key={`${field}_${value}_${index + 1}`} value={value}>{name}</Option>)
                        })
                    }
                </Select>
            </div>
        )
    }
}

FilterType.propTypes = {
    filters: PropTypes.object.isRequired,
    types: PropTypes.array,
    onChangeFilters: PropTypes.func.isRequired
}

export default FilterType